import React, { useState,useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { CSVLink } from 'react-csv';
import Image from 'mui-image';
import csv from 'src/img/csv.png';
import ButtonPolicy from "../../components/Permission/ButtonPolicy";
import pdf from 'src/img/pdf.png';
import 'chartjs-plugin-datalabels';
import ProjectBudgetForm from 'src/components/ReportHistory/ProjectBudgetForm';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import DatePicker from "react-datepicker";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

import "react-datepicker/dist/react-datepicker.css";

const DataGridComponent = ({ rows, columns }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const handleConfirmButton = () => {
    setIsOpen(false);

  }


  // Prepare data for CSV export


  return (
    <div style={{ width: '100%', marginBottom: 15 }}>
      <div className='datePicker'>
        <span onClick={() => setIsOpen(!isOpen)}><CalendarTodayIcon /></span>

        <span> {startDate.toLocaleDateString('en-GB', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        })} -
          {endDate.toLocaleDateString('en-GB', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          })}</span>

      </div>
      {isOpen && (
        <div className='dateDropdown'>
          <div className='startDatePicker'><span className='fromTo'>From:</span> <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} dateFormat="dd/MM/yyyy" /></div>
          <div className='endDatePicker'><span className='fromTo'>To:</span> <DatePicker selected={endDate} onChange={(date) => setEndDate(date)} /></div>
          <div className='confirmButton'>
            <ButtonPolicy color="primary" onClick={handleConfirmButton}>
              Confirm
            </ButtonPolicy>
          </div>
        </div>
      )}
      <DataGrid columns={columns} rows={rows} className='reportDataGrid' />
      {/* Add the CSVLink to trigger the CSV export */}

    </div>
  );
};

const App = () => {
   {/*Toggle for open form */}
   const [openProjectBudget, setopenProjectBudget]=useState(false);
   const [budgetData, setBudgetData]=useState([]);
   const [csvData,setCsvData]=useState([])
   const handleClickOpen = () => {
    setopenProjectBudget(true)
  };
  const handleClickClose = () => {
    setopenProjectBudget(false)
  }
  
  {/*define column for Datagrid table */}
  const columns = [
    { field: 'Status', headerName: 'Status', flex: 1 },
    { field: 'Name', headerName: 'Name', flex: 1 },
    { field: 'Budget', headerName: 'Budget', flex: 1 },
    { field: 'Spent', headerName: 'Spent', flex: 1 },
    {
      field: 'Balance',
      headerName: 'Balance',
      flex: 1,
      renderCell: (params) => {
        const balance = parseFloat(params.value);
        const isNegative = balance < 0;

        return (
          <div style={{ color: isNegative ? '#E16162' : 'green' }} className='Balance'>
            {isNegative ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}{params.value}
            
          </div>
        );
      },
    },
    { field: 'Period', headerName: 'Period', flex: 1 },
    { field: 'Team', headerName: 'Team', flex: 1 },
  ];


  return (
    <div>

      <div className='datagrid-container'>
      <ProjectBudgetForm visbile={openProjectBudget} onClose={handleClickClose}/>
        {/* Table */}
        <DataGridComponent rows={budgetData} columns={columns} />
        {/* Bottom right div */}
        <div className='bottom-container'>
          {/*Add budget button */}
          <div>
          <ButtonPolicy
           onClick={() => handleClickOpen()}
           className='addNewProject'
          >
            + Add New Project
          </ButtonPolicy>
          </div>
          {/*csv image button */}
          <CSVLink className='csvImageHolder' data={csvData} headers={columns.map((column) => ({
            label: column.headerName,
            key: column.field,
          }))}>
            
              <Image src={csv} />
            
          </CSVLink>
          {/*pdf image button */}
          <div className='csvImageHolder'>
            <Image src={pdf} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
